export default __webpack_public_path__ + "13b62811a00b40df1ae85bfb61b0c005.png";